import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { UPDATE_STORE } from './../../shared/index';
import { CVFormService } from './../coverage-form.service';

@Component({
  selector: 'pax-cf-form-application-status',
  template: require('./form-application-status.component.html')
})
export class FormApplicationStatusComponent implements OnInit {
  routeData;

  constructor(
    private _store: Store<any>,
    private _route: ActivatedRoute,
    private _cv: CVFormService
  ) {}

  ngOnInit() {
    // resolve router data
    this.routeData = this._route.data.subscribe((data) => {
      this._store.dispatch({ type: UPDATE_STORE, payload: { steps: data['forms'][1], settings: data['forms'][0] } });

    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-application-status/form-application-status.component.ts